<template>
  <div class="row">
    <div class="col-sm-12">

      <div class="row mt-4">
        <div class="col-md-12">
          <strong>
            {{ infoTotalModels }}
          </strong>
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>Feature Flag</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="flag in featureFlags" :key="flag">
            <td>{{ flag }}</td>
            <td>
              <router-link :to="`/admin/feature_flags/${encodeFlag(flag)}`" class="btn btn-outline">
                Ver Contas
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="col-md-12 my-1">
          <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
            @pagination="pagination" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Pagination from '@/components/shares/specialTag/Pagination'

export default {
  components: { Pagination },
  computed: {
    featureFlags() {
      return this.flags || []
    },
    infoTotalModels() {
      if (!this.flags || this.flags.length === 0)
        return 'Nenhum registro'

      return `Mostrando ${this.flags.length} feature flag(s)`
    }
  },
  created() {
    this.loadFeatureFlags()
  },
  data() {
    return {
      flags: [],
      meta: {
        currentPage: 1,
        totalCount: 0,
        totalPages: 1
      }
    }
  },
  methods: {
    encodeFlag(flag) {
      return encodeURIComponent(flag)
    },
    async loadFeatureFlags() {
      try {
        const response = await this.axios.v3.get('admin/feature_flags')
        this.flags = response.data || []
        this.meta.totalCount = this.flags.length
      } catch (error) {
        this.$notify.addError('Erro ao carregar feature flags')
      }
    },
    pagination() {
    }
  },
  name: 'FeatureFlagsIndex'
}
</script>

<style scoped>
* {
  color: black;
}
</style>
